export const Quote = () => {
  return (
    <div className="quote ">
      <div className="quote__overlay"></div>
      <div className="container section quote__content">
        <div className="quote__side">
          <h2 className="heading__secondary mt--huge mb--large">
            Watch how the site works and <br /> how to make a diagnosis
          </h2>
          <p className="paragraph">
            Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet
            sint. Velit officia consequat duis enim velit mollit. Exercitation
            veniam consequat sunt{" "}
          </p>
        </div>
        <div className="quote__side quote__side--play">
          <div className="quote__playbtn pointer">
            <PlayBtn />
          </div>
        </div>
      </div>
    </div>
  );
};
const PlayBtn = () => {
  return (
    <svg
      width="204"
      height="204"
      viewBox="0 0 204 204"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="102" cy="101" r="80.5" stroke="white" />
      <circle cx="102" cy="102" r="101.5" stroke="white" />
      <circle cx="101.943" cy="100.943" r="49.3958" fill="white" />
      <path
        d="M116.332 94.0221C121.665 97.1013 121.665 104.799 116.332 107.878L100.759 116.869C95.4254 119.949 88.7588 116.1 88.7588 109.941L88.7588 91.9593C88.7588 85.8009 95.4254 81.9519 100.759 85.0311L116.332 94.0221Z"
        fill="#246BFD"
      />
    </svg>
  );
};
